module.exports = __webpack_public_path__ + "static/media/iconEdit.621a6297.svg";